const audioFiles = {
  siren: require("./siren.wav"),
  voicecallHangup: require("./voicecall-hangup.wav"),
  voicecallRinging: require("./voicecall-ringing.wav"),
};
export default audioFiles;
